import axios from 'axios'
import QS from 'qs'

const baseURL = process.env.REACT_APP_COMPONENT_URL
const marketplaceURL = process.env.REACT_APP_COMPONENT_MARKETPLACE
const cache = {}
const NEW_REACT_NATIVE_VERSION = '0.77.2'
const OLD_REACT_NATIVE_VERSION = '0.74.2'

export const getLibraryDependencies = async(app, useNewReactNative = false) => {
  const { librariesUsed = [], OrganizationId, id: appId } = app

  const { data } = await axios.get(`${marketplaceURL}/api/libraries`, {
    params: {
      names: encodeURIComponent(
        JSON.stringify(['@protonapp/material-components', ...librariesUsed])
      ),
      orgId: OrganizationId,
      appId,
      versionRN: useNewReactNative
        ? NEW_REACT_NATIVE_VERSION
        : OLD_REACT_NATIVE_VERSION,
    },
  })

  return data
}

// Returns promise
export const loadLibrary = (name, version) => {
  const url = `${baseURL}/${name}/${version}/runtime-${version}.js`

  // Check if already in cache
  if (cache[url]) {
    return cache[url]
  }

  const script = document.createElement('script')
  script.src = url
  script.setAttribute('crossorigin', '')
  document.body.appendChild(script)

  const promise = new Promise((resolve, reject) => {
    script.addEventListener('load', () => {
      resolve()
    })

    script.addEventListener('error', () => {
      reject(new Error(`Script could not load: ${url}`))
    })
  })

  cache[url] = promise

  return promise
}

export const loadLibraries = async app => {
  const useNewReactNative = shouldUseNewReactNative(app)
  const libraryDependencies = await getLibraryDependencies(app, useNewReactNative)
  const promises = libraryDependencies.map(({ name, version }) => {
    return loadLibrary(name, version)
  })

  return Promise.allSettled(promises)
}

export const getParams = () => {
  return QS.parse(window.location.search.substring(1))
}

export const shouldUseNewReactNative = (app) => {
  return app?.useNewRNVersion
}

export const getLibraries = app => {
  return window.protonRuntime || {}
}
